/* Cart AJAX carries ?_fd=0 on purpose.

   A store served on its .myshopify.com address forwards requests to the
   primary domain. A POST to /cart/add.js lands in the .myshopify.com cart,
   but the follow-up GET /cart.js is forwarded to the primary domain, which
   keeps a different cart — so the drawer reads an empty cart while the
   customer's items sit in the other one. _fd=0 disables that forwarding, so
   every cart call stays on whichever domain the page was served from. It has
   no effect on the primary domain. */
/* =================================================================
   Guided builder

   One decision per screen. The tier chosen in step 1 is the variant
   that goes in the cart; add-ons and gift wrapping are separate line
   items, matching the product page exactly. Everything is assembled
   locally and committed in a single /cart/add.js call at the end, so
   a customer who abandons halfway leaves nothing behind in the cart.
   ================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-gb]');
  if (!root) return;

  var TOTAL_STEPS = 5;
  var step = 1;

  var state = {
    variantId: null,
    name: '',
    price: 0,
    compare: 0,
    panel: '',
    addons: [],          // { id, name, price }
    gift: false,
    props: {}
  };

  /* ---------- money ---------- */
  var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  function fmt(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';
    var n = (cents / 100.0).toFixed(precision);
    var parts = n.split('.');
    return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) +
           (parts[1] ? decimal + parts[1] : '');
  }
  function money(cents) {
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    var m = moneyFormat.match(ph);
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    return moneyFormat.replace(ph, v);
  }

  /* ---------- elements ---------- */
  var steps      = root.querySelectorAll('[data-gb-step]');
  var dots       = root.querySelector('[data-gb-dots]');
  // Two sets of controls now: the sticky bar and the in-flow one under the
  // step. Both are driven together so they can never disagree.
  var backBtns   = root.querySelectorAll('[data-gb-back]');
  var nextBtns   = root.querySelectorAll('[data-gb-next]');
  var submitBtns = root.querySelectorAll('[data-gb-submit]');
  function eachBtn(list, fn) { Array.prototype.forEach.call(list, fn); }
  var totalEl    = root.querySelector('[data-gb-total]');
  var totalLabel = root.querySelector('[data-gb-total-label]');
  var reviewEl   = root.querySelector('[data-gb-review]');

  var giftId    = parseInt(root.dataset.giftId, 10) || null;
  var giftCents = parseInt(root.dataset.giftCents, 10) || 0;
  // Start from the cheapest tier so the footer shows a real "from" price
  // rather than $0.00 before anything is chosen.
  var baseCents = parseInt(root.dataset.baseCents, 10) || 0;
  state.price = baseCents;

  /* ---------- progress ---------- */
  for (var i = 1; i <= TOTAL_STEPS; i++) {
    var node = document.createElement('span');
    node.className = 'gb__node';
    var d = document.createElement('span');
    d.className = 'gb__dot';
    d.textContent = i;
    node.appendChild(d);
    dots.appendChild(node);
  }
  var nodeEls = dots.querySelectorAll('.gb__node');
  var dotEls = dots.querySelectorAll('.gb__dot');

  function paintProgress() {
    dotEls.forEach(function (el, idx) {
      el.classList.toggle('is-done', idx + 1 < step);
      el.classList.toggle('is-current', idx + 1 === step);
    });
    // The line lives on the node it leads into, so it fills as soon as the
    // customer has reached that number.
    nodeEls.forEach(function (el, idx) {
      el.classList.toggle('is-linked', idx > 0 && idx + 1 <= step);
    });
  }

  /* ---------- totals ---------- */
  function addonsTotal() {
    return state.addons.reduce(function (s, a) { return s + a.price * (a.quantity || 1); }, 0);
  }
  function grandTotal() {
    return state.price + addonsTotal() + (state.gift ? giftCents : 0);
  }
  function paintTotal() {
    totalEl.textContent = money(grandTotal());
    var bits = [];
    if (state.name) bits.push(state.name);
    if (state.addons.length) bits.push(state.addons.length + ' extra' + (state.addons.length > 1 ? 's' : ''));
    if (state.gift) bits.push('gift wrapped');
    totalLabel.textContent = bits.length ? bits.join(' · ') : 'From';
  }

  /* ---------- step machine ---------- */
  function canAdvance() {
    // Only the tier is genuinely required — details are optional by design.
    if (step === 1) return !!state.variantId;
    return true;
  }

  function paintNav() {
    var last = step === TOTAL_STEPS;
    eachBtn(backBtns, function (b) { b.hidden = step === 1; });
    eachBtn(nextBtns, function (b) {
      b.hidden = last;
      b.disabled = !canAdvance();
      b.textContent = state.variantId ? 'Continue' : 'Choose an option';
    });
    eachBtn(submitBtns, function (b) { b.hidden = !last; });
  }

  function show(n) {
    step = Math.min(TOTAL_STEPS, Math.max(1, n));
    steps.forEach(function (s) {
      var on = Number(s.dataset.gbStep) === step;
      s.hidden = !on;
      s.classList.toggle('is-active', on);
    });
    if (step === 4) primeGift();
    if (step === 5) paintReview();
    paintProgress();
    paintNav();
    var stage = root.querySelector('.gb__stage');
    if (stage) stage.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  /* ---------- step 1: tiers ---------- */
  root.querySelectorAll('[data-gb-tier]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-gb-tier]').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      state.variantId = btn.dataset.variantId;
      state.name      = btn.dataset.name;
      state.price     = parseInt(btn.dataset.price, 10) || 0;
      state.compare   = parseInt(btn.dataset.compare, 10) || 0;
      state.panel     = btn.dataset.panel;

      // Only the chosen tier's panel exists for the customer.
      root.querySelectorAll('[data-gb-panel]').forEach(function (p) {
        p.hidden = p.dataset.gbPanel !== state.panel;
      });

      paintTotal();
      paintNav();
    });
  });

  /* ---------- step 2: DIY reveal ---------- */
  var diyToggle = root.querySelector('[data-gb-diy-toggle]');
  var diyPanel  = root.querySelector('[data-gb-diy-panel]');
  if (diyToggle && diyPanel) {
    diyToggle.addEventListener('change', function () {
      diyPanel.hidden = !diyToggle.checked;
      if (!diyToggle.checked) {
        diyPanel.querySelectorAll('[data-gb-prop], [data-upload-fallback]').forEach(function (i) { i.value = ''; });
      }
    });
  }

  /* ---------- step 3: add-ons ---------- */
  root.querySelectorAll('[data-gb-addon-wrap]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-gb-addon]');
    var qtyBox = wrap.querySelector('[data-gb-addon-qty]');
    var countEl = wrap.querySelector('[data-gb-addon-count]');
    if (!btn) return;
    var id = btn.dataset.variantId;

    function write(count) {
      state.addons = state.addons.filter(function (a) { return a.id !== id; });
      if (count > 0) {
        state.addons.push({
          id: id,
          name: btn.dataset.name,
          price: parseInt(btn.dataset.price, 10) || 0,
          quantity: count
        });
      }
      btn.classList.toggle('is-selected', count > 0);
      if (qtyBox) qtyBox.hidden = count < 1;
      if (countEl) countEl.textContent = String(count);
      paintTotal();
    }

    function current() {
      var found = state.addons.filter(function (a) { return a.id === id; })[0];
      return found ? (found.quantity || 1) : 0;
    }

    btn.addEventListener('click', function () { write(current() > 0 ? 0 : 1); });
    wrap.querySelector('[data-gb-addon-up]')?.addEventListener('click', function () {
      write(Math.min(99, current() + 1));
    });
    wrap.querySelector('[data-gb-addon-down]')?.addEventListener('click', function () {
      write(Math.max(0, current() - 1));
    });
  });

  /* ---------- step 4: gift ----------
     Wrapping is ticked on arrival at this step, not before. Turning it
     on from step one put the wrapped price against every ad click; this
     way the quoted price is the price, and wrapping is still the
     default once wrapping is actually the question being asked.
     ---------------------------------------------------------------- */
  var giftTouched = false;

  function primeGift() {
    if (giftTouched) return;
    var yes = root.querySelector('[data-gb-gift="yes"]');
    if (!yes) return;
    root.querySelectorAll('[data-gb-gift]').forEach(function (b) { b.classList.remove('is-selected'); });
    yes.classList.add('is-selected');
    state.gift = true;
    paintTotal();
  }

  root.querySelectorAll('[data-gb-gift]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      // An explicit choice sticks: coming back to this step must not
      // re-tick wrapping for someone who said no.
      giftTouched = true;
      root.querySelectorAll('[data-gb-gift]').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      state.gift = btn.dataset.gbGift === 'yes';
      paintTotal();
    });
  });

  /* ---------- properties ---------- */
  function collectProps() {
    var out = { 'Service Tier': state.name };
    // Upload boxes use data-prop-name, the same hook as the product page.
    root.querySelectorAll('[data-gb-prop], [data-prop-name]').forEach(function (inp) {
      // Skip anything belonging to a tier the customer did not pick.
      var panel = inp.closest('[data-gb-panel]');
      if (panel && panel.dataset.gbPanel !== state.panel) return;

      // Deliberately NOT a generic closest('[hidden]') check: by the time we
      // reach the review step, step 2's whole section is hidden, which would
      // silently discard every answer the customer gave. Only the two
      // genuinely optional reveals are excluded, by name.
      var diyReveal = inp.closest('[data-gb-diy-panel]');
      if (diyReveal && diyReveal.hidden) return;
  
      var v = (inp.value || '').trim();
      var key = inp.getAttribute('data-gb-prop') || inp.getAttribute('data-prop-name');
      if (v && key) out[key] = v;
    });
    return out;
  }

  /* ---------- step 5: review ---------- */
  var GALLERY_LINK = /^https:\/\/[^\s/]+\/g\/[A-Za-z0-9_-]{22}$/;
  function row(label, value, cls) {
    return '<div class="gb-row' + (cls ? ' ' + cls : '') + '">' +
           '<span>' + label + '</span><span>' + value + '</span></div>';
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
    });
  }

  function paintReview() {
    var html = '';
    html += row('Lahazati Video Book — ' + esc(state.name), money(state.price));
    state.addons.forEach(function (a) {
      var q = a.quantity || 1;
      html += row(esc(a.name) + (q > 1 ? ' \u00d7' + q : ''), '+' + money(a.price * q));
    });
    if (state.gift) html += row('Gift wrapping', '+' + money(giftCents));

    var props = collectProps();
    var detail = Object.keys(props).filter(function (k) { return k !== 'Service Tier'; });
    if (detail.length) {
      html += '<div class="gb-review__details"><span class="gb-review__details-title">Your details</span>';
      detail.forEach(function (k) {
        var shown = GALLERY_LINK.test(props[k])
          ? '<a href="' + esc(props[k]) + '" target="_blank" rel="noopener">Files attached — view</a>'
          : esc(props[k]);
        html += '<div class="gb-detail"><span>' + esc(k) + '</span><span>' + shown + '</span></div>';
      });
      html += '</div>';
    } else {
      html += '<p class="gb-note gb-note--soft">No details added yet — that is fine. We will message you on WhatsApp after your order to collect them.</p>';
    }
    html += row('Total', money(grandTotal()), 'gb-row--total');
    reviewEl.innerHTML = html;
  }

  /* ---------- navigation ---------- */
  eachBtn(nextBtns, function (b) { b.addEventListener('click', onNext); });
  function onNext() {
    if (!canAdvance()) return;
    // Nothing to ask a DIY customer about media, so skip straight to extras.
    if (step === 1 && state.panel === '' ) { show(3); return; }
    show(step + 1);
  }
  eachBtn(backBtns, function (b) {
    b.addEventListener('click', function () { show(step - 1); });
  });

  /* ---------- submit ---------- */
  function setSubmit(label, disabled) {
    eachBtn(submitBtns, function (b) {
      if (label !== null) b.textContent = label;
      b.disabled = disabled;
    });
  }

  eachBtn(submitBtns, function (b) { b.addEventListener('click', onSubmit); });
  async function onSubmit() {
    if (!state.variantId) return;
    var original = 'Add to Cart';
    setSubmit('Adding…', true);

    var items = [{ id: parseInt(state.variantId, 10), quantity: 1, properties: collectProps() }];
    state.addons.forEach(function (a) {
      items.push({ id: parseInt(a.id, 10), quantity: a.quantity || 1, properties: { 'For': 'Lahazati Video Book' } });
    });
    if (state.gift && giftId) {
      items.push({ id: giftId, quantity: 1, properties: { 'For': 'Lahazati Video Book' } });
    }

    // Step one: the only part that decides success or failure.
    try {
      var res = await fetch('/cart/add.js?_fd=0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) throw new Error('add failed (' + res.status + ')');
    } catch (err) {
      console.error('[Lahazati builder] add failed', err);
      setSubmit('Error — try again', true);
      setTimeout(function () { setSubmit(original, false); }, 2200);
      return;
    }

    // From here the order line exists. Everything below is presentation.
    setSubmit('Added', true);

    try {
      var cart = await fetch('/cart.js?_fd=0').then(function (r) { return r.json(); });
      document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count === 0 ? 'none' : 'flex';
      });
    } catch (err) {
      // Reading the cart back can fail on the .myshopify.com preview domain,
      // where /cart.js redirects to the primary domain and is blocked by CORS.
      // The badge stays stale; the cart itself is correct.
      console.warn('[Lahazati builder] could not refresh the cart count', err);
    }

    try {
      if (window.LahazatiCart && typeof window.LahazatiCart.open === 'function') {
        window.LahazatiCart.open();
        setTimeout(function () { setSubmit(original, false); }, 1200);
      } else {
        window.location.href = '/cart';
      }
    } catch (err) {
      console.warn('[Lahazati builder] could not open the cart drawer', err);
      setSubmit(original, false);
    }
  }

  /* ---------- boot ---------- */
  paintProgress();
  paintNav();
  paintTotal();
})();
